const PT = require("prop-types");
const React = require("react");
const Modal = require("./Modal");
const ConfirmModalShape = require("./ConfirmModalShape");

const card = require("./styles/ModalGeneral.css");
const styles = require("./styles/WhiteCardModal.css");

function WhiteCardModal(props) {
	const {
		onClose,
		styleType,
		size,
		fillColor,
		shadowColor,
		title,
		subtext,
		buttons,
		children,
		portalContainer,
		levelType = "default",
		contentClassName,
		buttonsExtraClassName,
	} = props;

	const titleId = React.useId();

	const resolvedStyleType = styleType || "default";
	const modalClass = [
		card.message,
		card[resolvedStyleType],
		card[size || "large"],
		styles.whiteCard,
	].join(" ");

	return (
		<div>
			<Modal
				onClose={onClose}
				closeOnBackdropClick={true}
				closeOnEsc={true}
				hasCloseButton={true}
				backdropClass={card.backdrop}
				modalClass={modalClass}
				portalContainer={portalContainer || null}
				levelType={levelType}
			>
				<div
					role="dialog"
					aria-labelledby={titleId}
					className={styles.dialogRegion}
				>
					<ConfirmModalShape
						className={card.bg}
						styleType={resolvedStyleType}
						fillColor={fillColor || "#ffffff"}
						shadowColor={shadowColor || "#FFC640"}
					/>
					{children}
					<div
						className={[styles.content, contentClassName]
							.filter(Boolean)
							.join(" ")}
					>
						<p id={titleId} className={styles.title}>
							{title}
						</p>
						{subtext && <p className={styles.subtext}>{subtext}</p>}
					</div>
					{buttons && (
						<div
							className={[card.buttons, styles.buttons, buttonsExtraClassName]
								.filter(Boolean)
								.join(" ")}
						>
							{buttons}
						</div>
					)}
				</div>
			</Modal>
		</div>
	);
}

WhiteCardModal.displayName = "WhiteCardModal";

WhiteCardModal.propTypes = {
	onClose: PT.func.isRequired,
	styleType: PT.string,
	size: PT.string,
	fillColor: PT.string,
	shadowColor: PT.string,
	title: PT.node.isRequired,
	subtext: PT.node,
	buttons: PT.node,
	children: PT.node,
	portalContainer: PT.string,
	levelType: PT.oneOf(["default", "aboveAll"]),
	contentClassName: PT.string,
	buttonsExtraClassName: PT.string,
};

WhiteCardModal.BUTTON_CLASS = card.button;

module.exports = WhiteCardModal;
